import Vue from 'vue'
import VueRouter from 'vue-router'
import UserList from '@/components/system/user/list'
import UserAdd from '@/components/system/user/add'
import UserEdit from '@/components/system/user/edit'
import ChangePwd from '@/components/system/user/changepwd'
import DictList from '@/components/system/dict/list'
import DictAdd from '@/components/system/dict/add'
import DictEdit from '@/components/system/dict/edit'
import LogList from '@/components/system/log/list'
import RoleList from '@/components/system/role/list'
import RoleAdd from '@/components/system/role/add'
import RoleEdit from '@/components/system/role/edit'
import OrgEdit from '@/components/system/org/edit'
import RoomList from '@/components/system/room/list'
import RoomAdd from '@/components/system/room/add'
import RoomEdit from '@/components/system/room/edit'
import NoticeList from '@/components/system/notice/noticelist'
import NoticeAdd from '@/components/system/notice/noticeadd'
import MsgList from '@/components/system/msg/msglist'
import MsgAdd from '@/components/system/msg/msgadd'
import ManageSecSet from '@/components/system/outapply/managesecset'
import ExamTimeManage from '@/components/system/outapply/examtimemanage'
import ExamTimeDisabledAdd from '@/components/system/outapply/examtimedisabledadd'
import ConfigLimit from '@/components/system/permission/configlimit'

import ZPGLUserList from '@/components/person/zpgluser/list'
import ZPGLUserEdit from '@/components/person/zpgluser/edit'
import TeachAdd from '@/components/person/teach/add'
import TeachList from '@/components/person/teach/list'
import TeachEdit from '@/components/person/teach/edit'
import TeachScoreList from '@/components/person/teach/scorelist'
import TeachScoreRecord from '@/components/person/teach/scorerecord'
import TeachImport from '@/components/person/teach/import'
import StuList from '@/components/person/stu/list'
import StuEdit from '@/components/person/stu/edit'
import StuImport from '@/components/person/stu/import'
import SectionSecretaryList from '@/components/person/sectionsecretary/list'
import SectionSecretaryAdd from '@/components/person/sectionsecretary/add'
import SectionSecretaryEdit from '@/components/person/sectionsecretary/edit'
import SetRange from '@/components/person/sectionsecretary/setrange'
import EvaluationList from '@/components/basicInfo/evaluation/list'
import EvaluationAdd from '@/components/basicInfo/evaluation/add'
import EvaluationEdit from '@/components/basicInfo/evaluation/edit'
import EvaluationInfo from '@/components/basicInfo/evaluation/info'
import StuScholarshipList from '@/components/basicInfo/scholarship/stulist'
import TecScholarshipList from '@/components/basicInfo/scholarship/teclist'
import MajorList from '@/components/basicInfo/major/list'
import MajorEdit from '@/components/basicInfo/major/edit'
import MajorAdd from '@/components/basicInfo/major/add'
import MonthlyStu from '@/components/achievement/monthly/stu'
import MonthlyStuDelay from '@/components/achievement/monthly/studelay'
import MonthlyStuList from '@/components/achievement/monthly/stulist'
import MonthlyTeach from '@/components/achievement/monthly/teach'
import MonthlyTeachList from '@/components/achievement/monthly/teachlist'
import MonthlyImport from '@/components/achievement/monthly/import'
import StuScore from '@/components/achievement/stu/score'
import StuScoreEdit from '@/components/achievement/stu/scoreedit'
import StuScoreEditDelay from '@/components/achievement/stu/scoreeditdelay'
import StuScoreReocrd from '@/components/achievement/stu/scorerecord'
import StuScoreRecordCheck from '@/components/achievement/stu/scorerecordcheck'
import StuScoreRecordCheckList from '@/components/achievement/stu/scorerecordchecklist'
import StuScoreRecordList from '@/components/achievement/stu/scorerecordlist'
import NoPut from '@/components/achievement/stu/noput'
import TecNoPut from '@/components/achievement/teach/tecnoput'
import StuDelayOutApply from '@/components/achievement/monthly/studelayoutapply'

import SectionSecretaryScore from '@/components/achievement/sectionsecretary/score'
import SectionSecretaryScoreRecord from '@/components/achievement/sectionsecretary/scorerecord'
import SectionSecretaryScoreRecordList from '@/components/achievement/sectionsecretary/scorerecordlist'

import AchievementStuImport from '@/components/achievement/stu/import'
import TeachScore from '@/components/achievement/teach/score'
import TeachScoreEdit from '@/components/achievement/teach/scoreedit'
import TeachScoreReocrd from '@/components/achievement/teach/scorerecord'
import TeachScoreRecordCheck from '@/components/achievement/teach/scorerecordcheck'
import TeachScoreRecordCheckList from '@/components/achievement/teach/scorerecordchecklist'
import TeachScoreRecordList from '@/components/achievement/teach/scorerecordlist'
import AchievementTeachImport from '@/components/achievement/teach/import'
import ResultsList from '@/components/achievement/stu/resultslist'
import ResultsImport from '@/components/achievement/stu/resultsimport'
import DeliverMoneyMonth from '@/components/achievement/set/delivermoneymonth'
import PlanStuList from '@/components/cycle/plan/stulist'
import PlanList from '@/components/cycle/plan/list'
import PlanSecList from '@/components/cycle/plan/seclist'
import PlanImport from '@/components/cycle/plan/import'
import PlanEdit from '@/components/cycle/plan/edit'
import PlanAdd from '@/components/cycle/plan/add'
import StuNoPlan from '@/components/cycle/plan/stunoplan'
import LeaveList from '@/components/cycle/leave/list'
import LeaveAdd from '@/components/cycle/leave/add'
import LeaveEdit from '@/components/cycle/leave/edit'

import OutAdd from '@/components/cycle/out/outadd'
import MidOutAdd from '@/components/cycle/out/midoutadd'
import OutCheckManage from '@/components/cycle/out/outcheckmanage'
import OutManage from '@/components/cycle/out/outmanage'
import OutMidExam from '@/components/cycle/out/outmidexam'
import OutEdit from '@/components/cycle/out/outedit'
import DelayOutApplyManage from '@/components/cycle/out/delayoutapplymanage'
import DelayOutApplyCheckManage from '@/components/cycle/out/delayoutapplycheckmanage'
import DelayOutAdd from '@/components/cycle/out/delayoutadd'
import DelayOutEdit from '@/components/cycle/out/delayoutedit'

import GraduateList from '@/components/cycle/graduate/list'
import Graduate from '@/components/cycle/graduate/graduate'
import StayAdd from '@/components/cycle/stay/add'
import StayList from '@/components/cycle/stay/list'
import StayEdit from '@/components/cycle/stay/edit'
import RoomRecordList from '@/components/cycle/stay/roomrecordlist'
import EntryList from '@/components/cycle/entry/list'
import EntriedList from '@/components/cycle/entry/entriedlist'
import UnEntryList from '@/components/cycle/entry/unentrylist'
import NoticePrint from '@/components/cycle/entry/noticeprint'

import AchievementMonthly from '@/components/report/achievement/monthly'
import AchievementStu from '@/components/report/achievement/stu'
import AchievementStuDelay from '@/components/report/achievement/studelay'
import AchievementStuDelayEvaluation from '@/components/report/achievement/studelayevaluation'
import AchievementStuMonth from '@/components/report/achievement/stumonth'
import AchievementTec from '@/components/report/achievement/tec'

import AchievementStuCompare from '@/components/report/achievement/stucompare'
import AchievementTecCompare from '@/components/report/achievement/teccompare'

import PaymentStuSection from '@/components/report/payment/stu/section'
import PaymentStuUser from '@/components/report/payment/stu/user'
import PaymentTeachSection from '@/components/report/payment/teach/section'
import PaymentTeachUser from '@/components/report/payment/teach/user'
import ScoreStuList from '@/components/report/score/stu/list'
import ScoreStuUser from '@/components/report/score/stu/user'
import ScoreStuScoreRecord from '@/components/report/score/stu/scorerecord'
import ScoreTeachList from '@/components/report/score/teach/list'
import ScoreTeachUser from '@/components/report/score/teach/user'
import SectionCycle from '@/components/report/cycle/sectioncycle'
import AbnormalStatistics from '@/components/report/cycle/abnormalstatistics'
import ScoreTeachScoreRecord from '@/components/report/score/teach/scorerecord'

import IndexSection from '@/components/index/section'
import IndexSystem from '@/components/index/system'
import IndexUserEdit from '@/components/index/useredit'

import StandardAdd from '@/components/standard/standardadd'
import StandardEdit from '@/components/standard/standardedit'
import StandardInfo from '@/components/standard/standardinfo'
import StandardList from '@/components/standard/standardlist'

import StandardSectionAdd from '@/components/standardsection/standardsectionadd'
import StandardSectionEdit from '@/components/standardsection/standardsectionedit'
import StandardSectionList from '@/components/standardsection/standardsectionlist'
import StandardSectionImport from '@/components/standardsection/standardsectionimport'

import NoteAdd from '@/components/note/noteadd'
import NoteEdit from '@/components/note/noteedit'
import NoteList from '@/components/note/notelist'

import DelayEvaluationList from '@/components/cycle/evaluation/list'
import DelayEvaluationAuditList from '@/components/cycle/evaluation/auditlist'

Vue.use(VueRouter)

let NoteRouter = [{
    path: '/main/note/noteadd',
    name: 'NoteAdd',
    component: NoteAdd
},
{
    path: '/main/note/noteedit',
    name: 'NoteEdit',
    component: NoteEdit
},
{
    path: '/main/note/notelist',
    name: 'NoteList',
    component: NoteList
}
]

let StandardSectionRouter = [{
    path: '/main/standardsection/standardsectionadd',
    name: 'StandardSectionAdd',
    component: StandardSectionAdd
},
{
    path: '/main/standardsection/standardsectionedit',
    name: 'StandardSectionEdit',
    component: StandardSectionEdit
},
{
    path: '/main/standardsection/standardsectionlist',
    name: 'StandardSectionList',
    component: StandardSectionList
},
{
    path: '/main/standardsection/standardsectionimport',
    name: 'StandardSectionImport',
    component: StandardSectionImport
}
]

let StandardRouter = [{
    path: '/main/standard/standardadd',
    name: 'StandardAdd',
    component: StandardAdd
},
{
    path: '/main/standard/standardedit',
    name: 'StandardEdit',
    component: StandardEdit
},
{
    path: '/main/standard/standardinfo',
    name: 'StandardInfo',
    component: StandardInfo
},
{
    path: '/main/standard/standardlist',
    name: 'StandardList',
    component: StandardList
}
]

let IndexRouter = [{
    path: '/main/index/section',
    name: 'IndexSection',
    component: IndexSection
},
{
    path: '/main/index/system',
    name: 'IndexSystem',
    component: IndexSystem
},
{
    path: '/main/index/useredit',
    name: 'IndexUserEdit',
    component: IndexUserEdit
}
]

let SystemRouter = [{
    path: '/main/system/user/list',
    name: 'UserList',
    component: UserList
},
{
    path: '/main/system/user/add',
    name: 'UserAdd',
    component: UserAdd
},
{
    path: '/main/system/user/edit',
    name: 'UserEdit',
    component: UserEdit
},
{
    path: '/main/system/user/changepwd',
    name: 'ChangePwd',
    component: ChangePwd
},
{
    path: '/main/system/dict/add',
    name: 'DictAdd',
    component: DictAdd
},
{
    path: '/main/system/dict/edit',
    name: 'DictEdit',
    component: DictEdit
},
{
    path: '/main/system/dict/list',
    name: 'DictList',
    component: DictList
},
{
    path: '/main/system/log/list',
    name: 'LogList',
    component: LogList
},
{
    path: '/main/system/role/list',
    name: 'RoleList',
    component: RoleList
},
{
    path: '/main/system/role/add',
    name: 'RoleAdd',
    component: RoleAdd
},
{
    path: '/main/system/role/edit',
    name: 'RoleEdit',
    component: RoleEdit
},
{
    path: '/main/system/room/list',
    name: 'RoomList',
    component: RoomList
},
{
    path: '/main/system/room/add',
    name: 'RoomAdd',
    component: RoomAdd
},
{
    path: '/main/system/room/edit',
    name: 'RoomEdit',
    component: RoomEdit
},
{
    path: '/main/system/notice/noticelist',
    name: 'NoticeList',
    component: NoticeList
},
{
    path: '/main/system/notice/noticeadd',
    name: 'NoticeAdd',
    component: NoticeAdd
},
{
    path: '/main/system/msg/msglist',
    name: 'MsgList',
    component: MsgList
},
{
    path: '/main/system/msg/msgadd',
    name: 'MsgAdd',
    component: MsgAdd
},
{
    path: '/main/system/org/edit',
    name: 'OrgEdit',
    component: OrgEdit
}, {
    path: '/main/system/outapply/managesecset',
    name: 'ManageSecSet',
    component: ManageSecSet
}, {
    path: '/main/system/outapply/examtimemanage',
    name: 'ExamTimeManage',
    component: ExamTimeManage
}, {
    path: '/main/system/outapply/examtimedisabledadd',
    name: 'ExamTimeDisabledAdd',
    component: ExamTimeDisabledAdd
}, {
    path: '/main/system/permission/configlimit',
    name: 'ConfigLimit',
    component: ConfigLimit
}
]

let PersonRouter = [{
    path: '/main/person/zpgluser/list',
    name: 'ZPGLUserList',
    component: ZPGLUserList
}, {
    path: '/main/person/zpgluser/edit',
    name: 'ZPGLUserEdit',
    component: ZPGLUserEdit
}, {
    path: '/main/person/teach/add',
    name: 'TeachAdd',
    component: TeachAdd
}, {
    path: '/main/person/teach/list',
    name: 'TeachList',
    component: TeachList
}, {
    path: '/main/person/teach/edit',
    name: 'TeachEdit',
    component: TeachEdit
}, {
    path: '/main/person/teach/scorelist',
    name: 'TeachScoreList',
    component: TeachScoreList
}, {
    path: '/main/person/teach/scorerecord',
    name: 'TeachScoreRecord',
    component: TeachScoreRecord
}, {
    path: '/main/person/teach/import',
    name: 'TeachImport',
    component: TeachImport
}, {
    path: '/main/person/stu/list',
    name: 'StuList',
    component: StuList
}, {
    path: '/main/person/stu/edit',
    name: 'StuEdit',
    component: StuEdit
}, {
    path: '/main/person/stu/import',
    name: 'StuImport',
    component: StuImport
}, {
    path: '/main/person/sectionsecretary/list',
    name: 'SectionSecretaryList',
    component: SectionSecretaryList
}, {
    path: '/main/person/sectionsecretary/add',
    name: 'SectionSecretaryAdd',
    component: SectionSecretaryAdd
}, {
    path: '/main/person/sectionsecretary/setrange',
    name: 'SetRange',
    component: SetRange
}, {
    path: '/main/person/sectionsecretary/edit',
    name: 'SectionSecretaryEdit',
    component: SectionSecretaryEdit
}]

let BasicInfoRouter = [{
    path: '/main/basicInfo/evaluation/list',
    name: 'EvaluationList',
    component: EvaluationList
},
{
    path: '/main/basicInfo/evaluation/add',
    name: 'EvaluationAdd',
    component: EvaluationAdd
},
{
    path: '/main/basicInfo/evaluation/edit',
    name: 'EvaluationEdit',
    component: EvaluationEdit
},
{
    path: '/main/basicInfo/evaluation/info',
    name: 'EvaluationInfo',
    component: EvaluationInfo
},
{
    path: '/main/basicInfo/scholarship/stulist',
    name: 'StuScholarshipList',
    component: StuScholarshipList
},
{
    path: '/main/basicInfo/scholarship/teclist',
    name: 'TecScholarshipList',
    component: TecScholarshipList
},
{
    path: '/main/basicInfo/major/list',
    name: 'MajorList',
    component: MajorList
},
{
    path: '/main/basicInfo/major/edit',
    name: 'MajorEdit',
    component: MajorEdit
},
{
    path: '/main/basicInfo/major/add',
    name: 'MajorAdd',
    component: MajorAdd
}
]

let AchievementRouter = [{
    path: '/main/achievement/monthly/stu',
    name: 'MonthlyStu',
    component: MonthlyStu
}, {
    path: '/main/achievement/monthly/studelay',
    name: 'MonthlyStuDelay',
    component: MonthlyStuDelay
}, {
    path: '/main/achievement/monthly/stulist',
    name: 'MonthlyStuList',
    component: MonthlyStuList
}, {
    path: '/main/achievement/stu/studelayoutapply',
    name: 'StuDelayOutApply',
    component: StuDelayOutApply
}, {
    path: '/main/achievement/monthly/teach',
    name: 'MonthlyTeach',
    component: MonthlyTeach
}, {
    path: '/main/achievement/monthly/teachlist',
    name: 'MonthlyTeachList',
    component: MonthlyTeachList
}, {
    path: '/main/achievement/monthly/import',
    name: 'MonthlyImport',
    component: MonthlyImport
}, {
    path: '/main/achievement/stu/score',
    name: 'StuScore',
    component: StuScore
}, {
    path: '/main/achievement/stu/scoreedit',
    name: 'StuScoreEdit',
    component: StuScoreEdit
}, {
    path: '/main/achievement/stu/scoreeditdelay',
    name: 'StuScoreEditDelay',
    component: StuScoreEditDelay
}, {
    path: '/main/achievement/stu/scorerecord',
    name: 'StuScoreReocrd',
    component: StuScoreReocrd
}, {
    path: '/main/achievement/stu/scorerecordcheck',
    name: 'StuScoreRecordCheck',
    component: StuScoreRecordCheck
}, {
    path: '/main/achievement/stu/scorerecordchecklist',
    name: 'StuScoreRecordCheckList',
    component: StuScoreRecordCheckList
}, {
    path: '/main/achievement/stu/scorerecordlist',
    name: 'StuScoreRecordList',
    component: StuScoreRecordList
}, {
    path: '/main/achievement/stu/noput',
    name: 'NoPut',
    component: NoPut
}, {
    path: '/main/achievement/teach/tecnoput',
    name: 'TecNoPut',
    component: TecNoPut
}, {
    path: '/main/achievement/sectionsecretary/score',
    name: 'SectionSecretaryScore',
    component: SectionSecretaryScore
}, {
    path: '/main/achievement/sectionsecretary/scorerecord',
    name: 'SectionSecretaryScoreRecord',
    component: SectionSecretaryScoreRecord
}, {
    path: '/main/achievement/sectionsecretary/scorerecordlist',
    name: 'SectionSecretaryScoreRecordList',
    component: SectionSecretaryScoreRecordList
}, {
    path: '/main/achievement/stu/import',
    name: 'AchievementStuImport',
    component: AchievementStuImport
}, {
    path: '/main/achievement/teach/score',
    name: 'TeachScore',
    component: TeachScore
}, {
    path: '/main/achievement/teach/scoreedit',
    name: 'TeachScoreEdit',
    component: TeachScoreEdit
}, {
    path: '/main/achievement/teach/scorerecord',
    name: 'TeachScoreReocrd',
    component: TeachScoreReocrd
}, {
    path: '/main/achievement/teach/scorerecordcheck',
    name: 'TeachScoreRecordCheck',
    component: TeachScoreRecordCheck
}, {
    path: '/main/achievement/teach/scorerecordchecklist',
    name: 'TeachScoreRecordCheckList',
    component: TeachScoreRecordCheckList
}, {
    path: '/main/achievement/teach/scorerecordlist',
    name: 'TeachScoreRecordList',
    component: TeachScoreRecordList
}, {
    path: '/main/achievement/teach/import',
    name: 'AchievementTeachImport',
    component: AchievementTeachImport
}, {
    path: '/main/achievement/stu/resultslist',
    name: 'ResultsList',
    component: ResultsList
}, {
    path: '/main/achievement/stu/resultsimport',
    name: 'ResultsImport',
    component: ResultsImport
}, {
    path: '/main/achievement/set/delivermoneymonth',
    name: 'DeliverMoneyMonth',
    component: DeliverMoneyMonth
}]

let CycleRouter = [{
    path: '/main/cycle/plan/list',
    name: 'PlanList',
    component: PlanList
},
{
    path: '/main/cycle/plan/stulist',
    name: 'PlanStuList',
    component: PlanStuList
},
{
    path: '/main/cycle/plan/seclist',
    name: 'PlanSecList',
    component: PlanSecList
},
{
    path: '/main/cycle/plan/import',
    name: 'PlanImport',
    component: PlanImport
},
{
    path: '/main/cycle/plan/add',
    name: 'PlanAdd',
    component: PlanAdd
},
{
    path: '/main/cycle/plan/stunoplan',
    name: 'StuNoPlan',
    component: StuNoPlan
},
{
    path: '/main/cycle/plan/edit',
    name: 'PlanEdit',
    component: PlanEdit
},
{
    path: '/main/cycle/leave/list',
    name: 'LeaveList',
    component: LeaveList
},
{
    path: '/main/cycle/leave/add',
    name: 'LeaveAdd',
    component: LeaveAdd
},
{
    path: '/main/cycle/leave/edit',
    name: 'LeaveEdit',
    component: LeaveEdit
},
{
    path: '/main/cycle/entry/unentrylist',
    name: 'UnEntryList',
    component: UnEntryList
},
{
    path: '/main/cycle/graduate/list',
    name: 'GraduateList',
    component: GraduateList
},
{
    path: '/main/cycle/graduate/graduate',
    name: 'Graduate',
    component: Graduate
},
{
    path: '/main/cycle/stay/add',
    name: 'StayAdd',
    component: StayAdd
},
{
    path: '/main/cycle/stay/roomrecordlist',
    name: 'RoomRecordList',
    component: RoomRecordList
},
{
    path: '/main/cycle/stay/list',
    name: 'StayList',
    component: StayList
},
{
    path: '/main/cycle/stay/edit',
    name: 'StayEdit',
    component: StayEdit
},
{
    path: '/main/cycle/entry/list',
    name: 'EntryList',
    component: EntryList
},
{
    path: '/main/cycle/entry/entriedlist',
    name: 'EntriedList',
    component: EntriedList
},
{
    path: '/main/cycle/entry/noticeprint',
    name: 'NoticePrint',
    component: NoticePrint
},
{
    path: '/main/cycle/out/outadd',
    name: 'OutAdd',
    component: OutAdd
},
{
    path: '/main/cycle/out/midoutadd',
    name: 'MidOutAdd',
    component: MidOutAdd
},
{
    path: '/main/cycle/out/delayoutadd',
    name: 'DelayOutAdd',
    component: DelayOutAdd
},
{
    path: '/main/cycle/out/delayoutedit',
    name: 'DelayOutEdit',
    component: DelayOutEdit
},
{
    path: '/main/cycle/out/outcheckmanage',
    name: 'OutCheckManage',
    component: OutCheckManage
},
{
    path: '/main/cycle/out/outmanage',
    name: 'OutManage',
    component: OutManage
},
{
    path: '/main/cycle/out/outmidexam',
    name: 'OutMidExam',
    component: OutMidExam
},
{
    path: '/main/cycle/out/outedit',
    name: 'OutEdit',
    component: OutEdit
},
{
    path: '/main/cycle/out/delayoutapplymanage',
    name: 'DelayOutApplyManage',
    component: DelayOutApplyManage
},
{
    path: '/main/cycle/out/delayoutapplycheckmanage',
    name: 'DelayOutApplyCheckManage',
    component: DelayOutApplyCheckManage
}
]

let ReportRouter = [{
    path: '/main/report/achievement/monthly',
    name: 'AchievementMonthly',
    component: AchievementMonthly
},
{
    path: '/main/report/achievement/stu',
    name: 'AchievementStu',
    component: AchievementStu
},
{
    path: '/main/report/achievement/studelay',
    name: 'AchievementStuDelay',
    component: AchievementStuDelay
},
{
    path: '/main/report/achievement/studelayevaluation',
    name: 'AchievementStuDelayEvaluation',
    component: AchievementStuDelayEvaluation
},
{
    path: '/main/report/achievement/stumonth',
    name: 'AchievementStuMonth',
    component: AchievementStuMonth
},
{
    path: '/main/report/achievement/tec',
    name: 'AchievementTec',
    component: AchievementTec
},
{
    path: '/main/report/achievement/stucompare',
    name: 'AchievementStuCompare',
    component: AchievementStuCompare
},
{
    path: '/main/report/achievement/teccompare',
    name: 'AchievementTecCompare',
    component: AchievementTecCompare
},
{
    path: '/main/report/payment/stu/section',
    name: 'PaymentStuSection',
    component: PaymentStuSection
},
{
    path: '/main/report/payment/stu/user',
    name: 'PaymentStuUser',
    component: PaymentStuUser
},
{
    path: '/main/report/payment/teach/section',
    name: 'PaymentTeachSection',
    component: PaymentTeachSection
},
{
    path: '/main/report/payment/teach/user',
    name: 'PaymentTeachUser',
    component: PaymentTeachUser
},
{
    path: '/main/report/score/stu/list',
    name: 'ScoreStuList',
    component: ScoreStuList
},
{
    path: '/main/report/score/stu/user',
    name: 'ScoreStuUser',
    component: ScoreStuUser
},
{
    path: '/main/report/score/stu/scorerecord',
    name: 'ScoreStuScoreRecord',
    component: ScoreStuScoreRecord
},
{
    path: '/main/report/score/teach/list',
    name: 'ScoreTeachList',
    component: ScoreTeachList
},
{
    path: '/main/report/score/teach/user',
    name: 'ScoreTeachUser',
    component: ScoreTeachUser
},
{
    path: '/main/report/score/teach/scorerecord',
    name: 'ScoreTeachScoreRecord',
    component: ScoreTeachScoreRecord
},
{
    path: '/main/report/cycle/sectioncycle',
    name: 'SectionCycle',
    component: SectionCycle
},
{
    path: '/main/report/cycle/abnormalstatistics',
    name: 'AbnormalStatistics',
    component: AbnormalStatistics
},
{
    path: '/main/cycle/evaluation/list',
    name: 'DelayEvaluationList',
    component: DelayEvaluationList
},
{
    path: '/main/cycle/evaluation/auditlist',
    name: 'DelayEvaluationAuditList',
    component: DelayEvaluationAuditList
}
]

const routes = new Set([...SystemRouter, ...PersonRouter, ...BasicInfoRouter, ...AchievementRouter, ...CycleRouter, ...
    ReportRouter, ...IndexRouter, ...StandardRouter, ...StandardSectionRouter, ...NoteRouter
])

const router = new VueRouter({
    mode: 'history',
    routes
})

// 防止出现重复点击菜单报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

export default router
